module.exports = __webpack_public_path__ + "static/media/centerAlign.bb026b62.svg";